/**
 * 红包类大屏舞台：红包雨 / 抢红包 / 刮刮乐等共用。
 * 数据来自 snapshot.gameData（winners / remainCount / remainAmount / totalCount）
 */
<template>
  <div class="rp-stage">
    <div class="rp-stage__bg" aria-hidden="true">
      <div class="rp-stage__glow rp-stage__glow--1" />
      <div class="rp-stage__glow rp-stage__glow--2" />
      <div class="rp-stage__rain">
        <i v-for="n in 14" :key="'rain-' + n" :style="rainStyle(n)" />
      </div>
    </div>

    <div class="rp-stage__head">
      <div class="rp-stage__banner">{{ label }}</div>
      <div class="rp-stage__stats">
        <div class="rp-card">
          <span class="rp-card__label">剩余红包</span>
          <strong class="rp-card__value">{{ remainCount }}<em>/{{ totalCount }}</em></strong>
        </div>
        <div class="rp-card">
          <span class="rp-card__label">剩余金额</span>
          <strong class="rp-card__value">¥{{ remainAmount }}</strong>
        </div>
        <div class="rp-card">
          <span class="rp-card__label">已抢人数</span>
          <strong class="rp-card__value">{{ grabbedCount }}</strong>
        </div>
      </div>
    </div>

    <div class="rp-list">
      <div v-for="(w, i) in winners" :key="(w.uid || i) + '-rp'" class="rp-item">
        <img v-if="w.avatar" class="rp-avatar" :src="w.avatar" alt="">
        <span v-else class="rp-avatar is-text">{{ (w.nick || '观').slice(0, 1) }}</span>
        <div class="rp-item__main">
          <div class="rp-nick">{{ w.nick || '观众' }}</div>
          <div class="rp-time">刚刚领取</div>
        </div>
        <span class="rp-amount">¥{{ w.amount }}</span>
      </div>
      <div v-if="!winners.length" class="rp-empty">
        <div class="rp-empty__title">等待观众抢红包…</div>
        <div class="rp-empty__tip">手机端进入互动页，点击「抢红包」即可参与</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RedPacketScreen',
  props: {
    gameData: { type: Object, default: () => ({}) },
    onlineCount: { type: Number, default: 0 },
    title: { type: String, default: '' }
  },
  computed: {
    winners() {
      return ((this.gameData && this.gameData.winners) || []).slice(-12)
    },
    remainCount() {
      return Number((this.gameData && this.gameData.remainCount) || 0)
    },
    remainAmount() {
      return Number((this.gameData && this.gameData.remainAmount) || 0).toFixed(2)
    },
    totalCount() {
      return Number((this.gameData && this.gameData.totalCount) || 0)
    },
    grabbedCount() {
      const gd = this.gameData || {}
      if (gd.grabbedCount != null) return Number(gd.grabbedCount) || 0
      return Math.max(0, this.totalCount - this.remainCount)
    },
    label() {
      return this.title || (this.gameData && this.gameData.label) || '抢红包'
    }
  },
  methods: {
    rainStyle(n) {
      const left = (n * 7.3) % 100
      return {
        left: left + '%',
        animationDelay: ((n % 7) * 0.9) + 's',
        animationDuration: (5.5 + (n % 5) * 0.8) + 's'
      }
    }
  }
}
</script>

<style scoped>
.rp-stage {
  position: absolute;
  inset: 0;
  overflow: hidden;
  color: #fff7ef;
}
.rp-stage__bg {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 40%, #5c1414 0%, #2a0a12 62%, #0d0408 100%);
  overflow: hidden;
}
.rp-stage__glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.45;
}
.rp-stage__glow--1 {
  width: 38vw;
  height: 38vw;
  left: 4%;
  top: 8%;
  background: rgba(255, 70, 60, 0.45);
  animation: rpFloat 9s ease-in-out infinite alternate;
}
.rp-stage__glow--2 {
  width: 32vw;
  height: 32vw;
  right: 4%;
  bottom: 6%;
  background: rgba(255, 190, 80, 0.35);
  animation: rpFloat 11s ease-in-out infinite alternate-reverse;
}
.rp-stage__rain i {
  position: absolute;
  top: -12vh;
  width: 12px;
  height: 18px;
  border-radius: 6px;
  background: linear-gradient(180deg, #ff6b5c, #d61f1f);
  box-shadow: 0 0 10px rgba(255, 90, 70, 0.35);
  opacity: 0.5;
  animation-name: rpRain;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.rp-stage__head {
  position: relative;
  z-index: 3;
  padding-top: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
}
.rp-stage__banner {
  display: inline-block;
  padding: 8px 36px;
  border-radius: 24px;
  background: linear-gradient(90deg, #ff8a3d, #e81f3d);
  font-size: 28px;
  letter-spacing: 4px;
  box-shadow: 0 0 24px rgba(255, 90, 60, 0.55);
}
.rp-stage__stats {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: center;
}
.rp-card {
  min-width: 168px;
  padding: 10px 20px;
  border-radius: 14px;
  text-align: center;
  background: rgba(20, 6, 10, 0.55);
  border: 1px solid rgba(255, 190, 120, 0.35);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.4);
}
.rp-card__label {
  display: block;
  font-size: 14px;
  letter-spacing: 2px;
  color: #ffc9a8;
  margin-bottom: 4px;
}
.rp-card__value {
  font-size: 30px;
  font-weight: 800;
  color: #ffe6a0;
  font-variant-numeric: tabular-nums;
  text-shadow: 0 0 18px rgba(255, 190, 80, 0.4);
}
.rp-card__value em {
  font-style: normal;
  font-size: 16px;
  color: #ffb89a;
}
.rp-list {
  position: absolute;
  left: 50%;
  top: 190px;
  bottom: 24px;
  transform: translateX(-50%);
  width: min(1400px, 88vw);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  grid-auto-rows: min-content;
  gap: 12px;
  align-content: end;
  overflow: hidden;
  z-index: 2;
}
.rp-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: rpIn 0.45s ease both;
}
.rp-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.25);
}
.rp-avatar.is-text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  color: #ffe6c4;
  background: linear-gradient(135deg, #7a2a2a, #3a1010);
}
.rp-item__main {
  flex: 1;
  min-width: 0;
  text-align: left;
}
.rp-nick {
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rp-time {
  font-size: 12px;
  color: #ffb89a;
  opacity: 0.8;
}
.rp-amount {
  font-size: 26px;
  font-weight: 800;
  color: #ffd666;
  font-variant-numeric: tabular-nums;
  text-shadow: 0 0 16px rgba(255, 190, 70, 0.45);
}
.rp-empty {
  grid-column: 1 / -1;
  margin: auto;
  text-align: center;
}
.rp-empty__title {
  font-size: 28px;
  font-weight: 600;
  color: #ffd9c6;
  margin-bottom: 10px;
}
.rp-empty__tip {
  font-size: 18px;
  color: #d99f86;
}
@keyframes rpIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
@keyframes rpFloat {
  from { transform: translate(0, 0) scale(1); }
  to { transform: translate(3%, 4%) scale(1.12); }
}
@keyframes rpRain {
  0% { transform: translateY(0) rotate(0); opacity: 0; }
  12% { opacity: 0.5; }
  100% { transform: translateY(120vh) rotate(18deg); opacity: 0; }
}
</style>
